import { useMemo } from "react";
import { StyleSheet, Text, View } from "react-native";

import { fontFamily } from "@passfirst/ui";

import { ReadinessRing } from "../../readiness-ring";
import { type Colors, useColors } from "../../theme";

interface Props {
  pct: number;
  title: string;
  sub: string;
  /** Web/wide home grows the ring 76 → 96 (design_handoff_2 §3). */
  large?: boolean;
}

// Navy hero card with a coral readiness ring + action-oriented copy.
// The ring color is hard-coded coral over the navy ground for legible
// contrast regardless of accuracy tier — color-by-tier is for the
// mastery rows further down.
export function ReadyCard({ pct, title, sub, large = false }: Props): JSX.Element {
  const colors = useColors();
  const styles = useMemo(() => makeStyles(colors), [colors]);
  return (
    <View style={styles.card}>
      <ReadinessRing
        pct={pct}
        size={large ? "md" : "sm"}
        arcColor={colors.action}
        trackColor="rgba(255,255,255,0.12)"
        textColor="#FFFFFF"
      />
      <View style={styles.textBlock}>
        <Text style={styles.title}>{title}</Text>
        <Text style={styles.sub}>{sub}</Text>
      </View>
    </View>
  );
}

function makeStyles(colors: Colors) {
  return StyleSheet.create({
    card: {
      backgroundColor: colors.surfaceBrand,
      borderWidth: 1,
      borderColor: colors.surfaceBrandBorder,
      borderRadius: 18,
      padding: 20,
      flexDirection: "row",
      alignItems: "center",
      gap: 18,
    },
    textBlock: { flex: 1, gap: 3 },
    title: {
      fontFamily: fontFamily.bold,
      fontSize: 17,
      color: "#FFFFFF",
    },
    sub: {
      fontFamily: fontFamily.regular,
      fontSize: 13,
      color: "#9FB2CC",
      lineHeight: 18,
    },
  });
}
